import i18n from 'i18next';

export default () => ([
  {
    label: i18n.t('repeat-by-date-with-example'),
    value: 'date',
  },
  {
    label: i18n.t('repeat-by-day-with-example'),
    value: 'day',
  },
]);
